module.exports = __webpack_public_path__ + "media/src/images/icons/garbage_can-1b2f340cbaf292727565a69a792031fa.svg";